import React, {Component} from 'react';
import '../../../../style/searchAccount.css'
import {AiOutlinePlus} from "react-icons/ai";
import {MdOutlineDeleteOutline, MdOutlineModeEditOutline} from "react-icons/md";
import {Link, NavLink} from "react-router-dom";
import BuildingContext from "../../../../contexts/Building";
import Skeleton from "react-loading-skeleton";
import FormControl from "@mui/material/FormControl";
import {Box, Button, CircularProgress, MenuItem, Select} from "@mui/material";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import {green, red} from "@mui/material/colors";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import { API_BASE_URL } from '../../../../api/client';
import {downloadCsv} from '../../../../utils/csvExport';
import ListPagination, {paginateItems} from '../../../CustomInputs/ListPagination';

class SearchPersonnel extends Component {
    static contextType = BuildingContext;

    state = {
        searchLoading: true,
        deleteLoading: false,
        placeholder: '',
        accountsFound: [],
        searchInput: "",
        searchType: "fullName",
        selectedAccount: {},
        showDeleteModal: false,
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
        newEmail: '',
        showEditModal: false,
        showCurrentPassword: false,
        showNewPassword: false,
        editField: "password",
        listPage: 1,
        pageSize: 20,
    }

    async componentDidMount() {
        this.setState({searchLoading: true})
        axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/search?parentType=Personnel`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => this.setState({
                accountFound: data,
                searchLoading: false
            })).catch(() => {
            if (localStorage.getItem('role') === 'MANAGER') {
                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/search?parentType=Personnel`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => this.setState({
                                    accountFound: data,
                                    searchLoading: false
                                }))
                        } else {
                            window.location = '/'
                        }
                    })
            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/search?parentType=Personnel`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => this.setState({
                                    accountFound: data,
                                    searchLoading: false
                                }))
                        } else {
                            window.location = '/'
                        }
                    })
            }})
    }

    render() {
        return (
            <>
                <div className="page-title-row">
                    <h4>
                        پرسنل
                    </h4>
                    <div className="page-actions">
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-success"
                            onClick={this.exportExcel}
                        >
                            خروجی اکسل
                        </button>
                        {
                            localStorage.getItem('role') === 'MANAGER'
                                ? <NavLink to={'/dashboard/PersonnelRegister'} className="btn-done d-flex align-items-center justify-content-center my-0">
                                    <AiOutlinePlus className='ms-2'/>افزودن پرسنل
                                </NavLink>
                                : null
                        }
                        <Link className="back-btn" to="/dashboard">
                            بازگشت
                            <i className="bi bi-caret-left-fill"/>
                        </Link>
                    </div>
                </div>

                <div className="search-box search-toolbar">
                    <div className="search-field">
                        <span className="search-field-label">براساس</span>
                        <FormControl fullWidth size="small">
                            <Select
                                className="search-select"
                                value={this.state.searchType}
                                onChange={(value) => this.setState({searchType: value.target.value})}
                                displayEmpty
                            >
                                <MenuItem value={"fullName"}>نام و نام خانوادگی</MenuItem>
                                <MenuItem value={"nationalCode"}>کد ملی</MenuItem>
                                <MenuItem value={"phoneNumber"}>شماره تلفن</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="search-field search-field-grow">
                        <span className="search-field-label">جستجو</span>
                        <div className="search-input-wrap">
                            <i className="bi bi-search" aria-hidden="true"/>
                            <input
                                type="text"
                                disabled={this.state.showEditModal}
                                id="inputSearch"
                                placeholder="نام، کد ملی یا شماره تلفن…"
                                onChange={this.handleSearchInput}
                            />
                        </div>
                    </div>
                </div>
                <div className="table-box">
                    <table className="table">
                        <thead>
                        <tr>
                            <th>نام</th>
                            <th>تلفن</th>
                            <th>کد ملی</th>
                            <th>عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.searchLoading ?
                                [...Array(5)].map((x, i) => (
                                    <tr key={i}>
                                        <td><Skeleton animation="wave" height={20} width="100%"/></td>
                                        <td><Skeleton animation="wave" height={20} width="100%"/></td>
                                        <td><Skeleton animation="wave" height={20} width="100%"/></td>
                                        <td><Skeleton animation="wave" height={20} width="100%"/></td>
                                    </tr>
                                ))
                                :
                                (() => {
                                    const {pageItems} = paginateItems(
                                        this.state.accountFound || [], this.state.listPage, this.state.pageSize
                                    );
                                    if (pageItems.length === 0) {
                                        return (
                                            <tr className="table-empty-row">
                                                <td colSpan={4}>موردی یافت نشد</td>
                                            </tr>
                                        );
                                    }
                                    return pageItems.map(accountFound => (
                                        <tr key={accountFound.id}>
                                            <td>
                                                <Link
                                                    to={accountFound.id}
                                                    className="table-row-link"
                                                    onClick={() => {
                                                        this.context.handlePersonId(accountFound.parentId, accountFound.id)
                                                    }}
                                                >
                                                    {accountFound.fullName}
                                                </Link>
                                            </td>
                                            <td>{accountFound.phoneNumber}</td>
                                            <td>{accountFound.nationalCode}</td>
                                            <td>
                                                <div className="table-actions">
                                                    {
                                                        localStorage.getItem('role') === "MANAGER" ?
                                                            <>
                                                                <button
                                                                    type="button"
                                                                    className="icon-btn icon-btn-danger"
                                                                    title="حذف"
                                                                    onClick={() => {
                                                                        this.setState({selectedAccount: accountFound, showDeleteModal: true})
                                                                    }}
                                                                >
                                                                    <MdOutlineDeleteOutline size={15}/>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="icon-btn icon-btn-warning"
                                                                    title="ویرایش"
                                                                    onClick={() => {
                                                                        this.setState({selectedAccount: accountFound, showEditModal: true})
                                                                    }}
                                                                >
                                                                    <MdOutlineModeEditOutline size={15}/>
                                                                </button>
                                                            </>
                                                            : null
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    ));
                                })()
                        }
                        </tbody>
                    </table>
                </div>
                {
                    !this.state.searchLoading && (() => {
                        const {totalPages, page, total} = paginateItems(
                            this.state.accountFound || [], this.state.listPage, this.state.pageSize
                        );
                        return (
                            <>
                                <div className="text-muted small text-center mt-2">از {total} مورد</div>
                                <ListPagination
                                    page={page}
                                    totalPages={totalPages}
                                    onNewPage={(p) => this.setState({listPage: p})}
                                />
                            </>
                        );
                    })()
                }
                <Modal
                    style={{left: "50%", translate: "-50%"}}
                    className={"w-25"}
                    centered={true}
                    show={this.state.showDeleteModal}
                    size={'xl'}
                    onHide={() => this.setState({showDeleteModal : false})}
                >
                    <Modal.Header closeButton={true}>
                        <Modal.Title>حذف پرسنل</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>آیا از حذف پرسنل {this.state.selectedAccount.fullName} مطمئن هستید؟</Modal.Body>
                    <Modal.Footer>
                        {/* Cancel button for delete account modal */}
                        <button disabled={this.state.deleteLoading} className="btn btn-light" onClick={() => {this.setState({showDeleteModal: false})}}>لغو</button>

                        {/* Confirm button for deleting account */}
                        <Box sx={{ m: 1, position: 'relative' }}>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#dc3545",
                                    color: "black",
                                    ":hover": {backgroundColor: "#a52834", color: "white"}
                                }}
                                disabled={this.state.deleteLoading}
                                onClick={() => {
                                    this.handleDelete(this.state.selectedAccount.id);
                                }}
                            >
                                حذف
                            </Button>
                            {this.state.deleteLoading && (
                                <CircularProgress
                                    size={24}
                                    sx={{
                                        color: red[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                    }}
                                />
                            )}
                        </Box>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={this.state.showEditModal}
                    onHide={() => this.setState({showEditModal: false})}
                    centered={true}
                >
                    <Modal.Header closeButton={true}>
                        <h4>تغییر اطلاعات {this.state.selectedAccount.fullName}</h4>
                    </Modal.Header>
                    <Modal.Body>
                        <FormControl>
                            {/*<FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel>*/}
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={this.state.editField}
                                onChange={(e) => {
                                    this.setState({editField: e.target.value})
                                }}
                            >
                                <FormControlLabel value="password" control={<Radio />} label="تغییر گذرواژه" />
                                <FormControlLabel value="email" control={<Radio />} label="تغییر ایمیل" />
                            </RadioGroup>
                        </FormControl>
                        {
                            this.state.editField === "password" ?
                                <>
                                    <div className="input-group-register col-md-4 col-12 mt-4"
                                         style={{width: '100%'}}
                                    >
                                        <input type={this.state.showCurrentPassword ? "text" : "password"}
                                               className={`input form-control`}
                                               value={this.state.currentPassword}
                                               onChange={(e) => this.setState({currentPassword: e.target.value})}
                                               placeholder=" "
                                        />
                                        <label className="placeholder">
                                            گذرواژه فعلی
                                        </label>
                                    </div>
                                    <div className="mx-4 d-flex align-item-center">
                                        <div className={"chk-show d-flex align-items-center justify-content-center"} onClick={
                                            () => this.setState({showCurrentPassword: !this.state.showCurrentPassword})
                                        }>
                                            <input type="checkbox" checked={this.state.showCurrentPassword}/>
                                        </div>
                                        <label htmlFor="chk-show" className={"m-2"} style={{fontSize: "0.7rem", userSelect: 'none'}}>نمایش گذرواژه فعلی</label>
                                    </div>
                                    <div className="input-group-register col-md-4 col-12 mt-4"
                                         style={{width: '100%'}}
                                    >
                                        <input type={this.state.showNewPassword ? "text" : "password"}
                                               className={`input form-control`}
                                               value={this.state.newPassword}
                                               onChange={(e) => this.setState({newPassword: e.target.value})}
                                               placeholder=" "
                                        />
                                        <label className="placeholder">
                                            گذرواژه جدید
                                        </label>
                                    </div>
                                    <div className="input-group-register col-md-4 col-12 mt-2"
                                         style={{width: '100%'}}
                                    >
                                        <input type={this.state.showNewPassword ? "text" : "password"}
                                               className={`input form-control`}
                                               value={this.state.confirmNewPassword}
                                               onChange={(e) => this.setState({confirmNewPassword: e.target.value})}
                                               placeholder=" "
                                        />
                                        <label className="placeholder">
                                            تکرار گذرواژه جدید
                                        </label>
                                    </div>
                                    <div className="mx-4 d-flex align-item-center">
                                        <div className={"chk-show d-flex align-items-center justify-content-center"} onClick={
                                            () => this.setState({showNewPassword: !this.state.showNewPassword})
                                        }>
                                            <input type="checkbox" checked={this.state.showNewPassword}/>
                                        </div>
                                        <label htmlFor="chk-show" className={"m-2"} style={{fontSize: "0.7rem", userSelect: 'none'}}>نمایش گذرواژه جدید</label>
                                    </div>

                                </>
                                :
                                <div className="input-group-register col-md-4 col-12 mt-4"
                                     style={{width: '100%'}}
                                >
                                    <input type={"text"}
                                           className={`input form-control`}
                                           value={this.state.newEmail}
                                           onChange={(e) => this.setState({newEmail: e.target.value})}
                                           placeholder=" "
                                    />
                                    <label className="placeholder">
                                        ایمیل جدید
                                    </label>
                                </div>

                        }
                            </Modal.Body>
                    <Modal.Footer>
                        {/* Submit button for edit detail modal */}
                        <Box sx={{ m: 1, position: 'relative' }}>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#20d489",
                                    color: "black",
                                    ":hover": {backgroundColor: "#198754", color: "white"}
                                }}
                                disabled={this.state.deleteLoading}
                                onClick={() => this.changeDetail()}
                            >
                                ثبت
                            </Button>
                            {this.state.deleteLoading && (
                                <CircularProgress
                                    size={24}
                                    sx={{
                                        color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                    }}
                                />
                            )}
                        </Box>

                        {/* Close button for submitting edit detail */}
                        <button disabled={this.state.deleteLoading} className="btn btn-light" onClick={() => this.setState({showEditModal : false})}>بستن</button>
                    </Modal.Footer>
                </Modal>

            </>
        );
    }
    //search
    exportExcel = () => {
        downloadCsv('personnel.csv', ['نام', 'تلفن', 'کد ملی'], (this.state.accountFound || []).map((a) => [
            a.fullName,
            a.phoneNumber,
            a.nationalCode,
        ]));
    }

    handleSearchInput = async (e) => {
        const value = e.target.value;
        this.setState({searchInput: value, searchLoading: true, listPage: 1});
        axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/search?parentType=Personnel&${this.state.searchType}=${e.target.value}`,
            {headers: {
                    'Authorization': localStorage.getItem('accessToken'),
                    'Access-Control-Allow-Origin': '*'
                }}).then(response => response.data)
            .then((data) => this.setState({
                accountFound: data,
                searchLoading: false
            })).catch(() => {
            if (localStorage.getItem('role') === 'MANAGER') {
                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/search?parentType=Personnel&${this.state.searchType}=${e.target.value}`,
                                {headers: {
                                        'Authorization': localStorage.getItem('accessToken'),
                                        'Access-Control-Allow-Origin': '*'
                                    }}).then(response => response.data)
                                .then((data) => this.setState({
                                    accountFound: data,
                                    searchLoading: false
                                }))
                        } else {
                            window.location = '/'
                        }
                    })
            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/search?parentType=Personnel&${this.state.searchType}=${e.target.value}`,
                                {headers: {
                                        'Authorization': localStorage.getItem('accessToken'),
                                        'Access-Control-Allow-Origin': '*'
                                    }}).then(response => response.data)
                                .then((data) => this.setState({
                                    accountFound: data,
                                    searchLoading: false
                                }))
                        } else {
                            window.location = '/'
                        }
                    })
            }})
    }
    async handleDelete(charId) {
        this.setState({deleteLoading: true})

        let respondChar = ''
        await axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => {
                respondChar = data
            }).catch(async () => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then(async (response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                await axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    .then((data) => {
                                        respondChar = data
                                    })
                            } else {
                                window.location = '/'
                            }
                        })
                }
            })


        await axios.delete(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .catch(() => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then((response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                axios.delete(`${API_BASE_URL}/api/v1/supervisor/characteristic/${charId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                            } else {
                                window.location = '/'
                            }
                        })
                }
            })

        await axios.delete(`${API_BASE_URL}/api/v1/supervisor/personnel/${respondChar.parentId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .catch(() => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then((response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                axios.delete(`${API_BASE_URL}/api/v1/supervisor/personnel/${respondChar.parentId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                            } else {
                                window.location = '/'
                            }
                        })
                }
            })

        this.setState({deleteLoading: false, showDeleteModal: false})
        this.componentDidMount()
    }

    async changeDetail() {
        this.setState({deleteLoading: true})
        console.log(123)
        if (this.state.editField === "password") {
            console.log(345)
            const body = {
                username: this.state.selectedAccount.fullName,
                oldPassword: this.state.currentPassword,
                newPassword: this.state.newPassword,
                role: "SUPERVISOR"}
            await axios.post(`${API_BASE_URL}/api/v1/changePassword`, body, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                .catch(() => {
                        if (localStorage.getItem('role') === 'MANAGER') {
                            axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then((response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        axios.post(`${API_BASE_URL}/api/v1/changePassword`, body, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        }
                    }
                )
        } else {
            const body = {
                username: this.state.selectedAccount.fullName,
                email: this.state.newEmail,
                role: `SUPERVISOR`
            }
            await axios.post(`${API_BASE_URL}/api/v1/changePassword`, body, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                .catch(() => {
                        if (localStorage.getItem('role') === 'MANAGER') {
                            axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then((response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        axios.post(`${API_BASE_URL}/api/v1/changePassword`, body, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        }
                    }
                )
        }
        this.setState({deleteLoading: false})
    }
}

export default SearchPersonnel;